export default "__VITE_ASSET__boluvgNA__"